
import { Node } from "models/nodes/Node";
import { TeamReview } from "./TeamReview";
import { TeamReviewDecision } from "./TeamReviewDecision";
import { UserSubmission } from "./UserSubmission";
import { Enrollment } from "models/enrollments/Enrollment";
import { EnrollmentSubmission } from "models/enrollments/EnrollmentSubmission";
import { Team } from "models/teams/Team";
import { Status } from "./Status";

export class Project {
    projectId: string = "";
    userId: string = "";
    teamId: string = "";
    workflowId: string = "";
    ownerName: string = "";
    name: string = "";
    description: string = ""
    status: Status = Status.InProgress
    enrollmentSubmissions: Array<EnrollmentSubmission> = [];
    team: Team | null = null;

        getStatus(): string {
            //console.log('Getting status for project:', this.projectId, 'Status:', this.status);
        const status = typeof this.status === 'number' ? this.status : Number(this.status ?? -1);

        switch (status) {
            case 0:
                return "In Progress";
            case 1:
                return "Denied";
            case 2:
                return "Completed";
            default:
                return "Unknown Status";
        }
    }
}